import { render, staticRenderFns } from "./StaffSelector.vue?vue&type=template&id=2719adbf"
import script from "./StaffSelector.vue?vue&type=script&lang=js"
export * from "./StaffSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports